import { render } from "./GameEdit.vue?vue&type=template&id=162e130c&scoped=true"
import script from "./GameEdit.vue?vue&type=script&lang=js"
export * from "./GameEdit.vue?vue&type=script&lang=js"

import "./GameEdit.vue?vue&type=style&index=0&id=162e130c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-162e130c"

export default script